import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCompare = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M5.29297 17.584H14.707M4.35156 4.4043L10 3.46289L15.6484 4.4043M4.35156 4.4043L7.17578 10.0527C7.17578 10.8018 6.87823 11.5201 6.34859 12.0498C5.81894 12.5794 5.10059 12.877 4.35156 12.877C3.60253 12.877 2.88418 12.5794 2.35454 12.0498C1.82489 11.5201 1.52734 10.8018 1.52734 10.0527L4.35156 4.4043ZM15.6484 4.4043L18.4727 10.0527C18.4727 10.8018 18.1751 11.5201 17.6455 12.0498C17.1158 12.5794 16.3975 12.877 15.6484 12.877C14.8994 12.877 14.1811 12.5794 13.6514 12.0498C13.1218 11.5201 12.8242 10.8018 12.8242 10.0527L15.6484 4.4043ZM10 1.58008V17.584",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
const ForwardRef = forwardRef(SvgCompare);
export { ForwardRef as ReactComponent };
